import { Button, Card, CardContent, CardHeader, FormHelperText } from '@mui/material';
import { Link, Stack, TextField, Typography } from '@mui/material';
import { RouterLink } from 'src/components/router-link';
import { Seo } from 'src/components/seo';
import { usePageView } from 'src/hooks/use-page-view';
import { paths } from 'src/paths';
import { useRouter } from 'src/hooks/use-router';
import useViewModel from 'src/api/resetPassword/view-model';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { tokens } from 'src/locales/tokens';
import { formikFieldHandlers } from 'src/components/formik-helper';

const Page = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const onSuccess = (result) => {
    toast.success(result, { duration: 3000 });
    router.push(paths.myauth.index);
  };
  const { formik } = useViewModel(onSuccess);
  const { handleFieldChange, handleFieldBlur } = formikFieldHandlers(formik);

  usePageView();

  return (
    <>
      <Seo title="Reset Password" />
      <Card elevation={16}>
        <CardHeader
          subheader={
            <Typography color="text.secondary" variant="body2">
              Bạn đã có tài khoản? &nbsp;
              <Link
                component={RouterLink}
                to={paths.myauth.index}
                underline="hover"
                variant="subtitle2"
              >
                {t(tokens.nav.login)}
              </Link>
            </Typography>
          }
          sx={{ pb: 0 }}
          title="Cài lại mật khẩu"
        />
        <CardContent>
          <form noValidate onSubmit={formik.handleSubmit}>
            <Stack spacing={3}>
              <TextField
                autoFocus
                error={!!(formik.touched.user && formik.errors.user)}
                fullWidth
                helperText={formik.touched.user && formik.errors.user}
                label="Mã đăng nhập"
                name="user"
                onBlur={handleFieldBlur}
                onChange={handleFieldChange}
                type="text"
                value={formik.values.user}
                variant='outlined'
              />
              <TextField
                error={!!(formik.touched.email && formik.errors.email)}
                fullWidth
                helperText={formik.touched.email && formik.errors.email}
                label="Email"
                name="email"
                onBlur={handleFieldBlur}
                onChange={handleFieldChange}
                type="text"
                value={formik.values.email}
                variant='outlined'
              />
            </Stack>
            {formik.errors.submit && (
              <FormHelperText error sx={{ mt: 3 }}>
                {formik.errors.submit}
              </FormHelperText>
            )}
            <Button
              disabled={formik.isSubmitting}
              fullWidth
              size="large"
              sx={{ mt: 3 }}
              type="submit"
              variant="contained"
            >
              Gửi thông tin
            </Button>
          </form>
        </CardContent>
      </Card>
    </>
  );
};

export default Page;
